module.exports = __webpack_public_path__ + "icon_not_rech.png";